import { render, staticRenderFns } from "./talk-navbar.vue?vue&type=template&id=575dd92e&scoped=true"
import script from "./talk-navbar.vue?vue&type=script&lang=js"
export * from "./talk-navbar.vue?vue&type=script&lang=js"
import style0 from "./talk-navbar.vue?vue&type=style&index=0&id=575dd92e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575dd92e",
  null
  
)

export default component.exports